import type { NextIncomingMessage } from 'next/dist/server/request-meta';
import { APIClientError } from './ApiClientError';

export class APIForbiddenError extends APIClientError {
    constructor(message: string, response?: Response, req?: NextIncomingMessage) {
        super(message, response, req);
        this.name = 'APIForbiddenError';
    }
}
